import i18n from 'i18next';
import { AutostahlLocation, Make, ServiceBookingForm, ServiceSlot } from '../types';

// Use the current webpage origin as the API base to ensure requests go to the correct host
const BASE_URL = `${window.location.origin}/_service-booking`;

export function createServiceBookingApi() {
    const asJson = async (res: any) => {
        if (!res.ok) {
            const text = await res.text().catch(() => '');
            if (window.location.origin.includes('basewebsite.ddev.site')) {
                alert(`Die Auto Stahl API ist nur über das Code Q VPN erreichbar. Bitte gehe sicher, verbunden zu sein. HTTP-Fehler ${res.status} ${res.statusText}${text ? `: ${text}` : ''}`);
            } else {
                alert(i18n.t('error.loadDataFailed'));
            }
            throw new Error(`HTTP ${res.status} ${res.statusText}${text ? `: ${text}` : ''}`);
        }
        return res.json();
    };

    return {
        async getLocations(language: string): Promise<AutostahlLocation[]> {
            const res = await fetch(`${BASE_URL}/locations.json?language=${language}`);
            return asJson(res);
        },

        async getMakes(): Promise<Make[]> {
            const res = await fetch(`${BASE_URL}/makes.json`);
            return asJson(res);
        },

        async getServiceSlots(
            betriebsnummer: number,
            servicepaket: string,
            fabrikatCode: string
        ): Promise<ServiceSlot[]> {
            const res = await fetch(
                `${BASE_URL}/serviceSlots.json?betriebsnummer=${betriebsnummer}&servicepaket=${servicepaket}&fabrikat_code=${fabrikatCode}`
            );
            return asJson(res);
        },

        async postBookService(form: ServiceBookingForm): Promise<{ success: true } | { error: string }> {
            const res = await fetch(`${BASE_URL}/bookService.json`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(form),
            });

            return asJson(res);
        },
    };
}

const api = createServiceBookingApi();

export default api;
